import { Component, OnInit, ViewChild } from '@angular/core';
import { GridComponent, PageSettingsModel } from '@syncfusion/ej2-angular-grids';
import { Subject } from 'rxjs';
import { clientTemplate, employeeTemplate, onBoardingtemplateBO } from '../agreement-template/agreement-template.model';
import { AgreementTemplateService } from '../agreement-template/agreement-template.service';
import { ClientHttpService } from '../client-parent/client-parent.service';
import { GlobalComponent } from 'src/app/global/global.component';
import { takeUntil } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
// import { HandBookSaveBo } from './handbook.model';
import { HandBookService } from './handbook.service';
import { GetHandbookBO, HandbookBO, functionpermission } from './handbook.model';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-handbook',
  templateUrl: './handbook.component.html',
  styleUrls: ['./handbook.component.scss']
})
export class HandbookComponent implements OnInit {

 
  @ViewChild('grid') public grid: GridComponent;
  @ViewChild('gridEmp') public gridEmp: GridComponent;

  public pageSettings: PageSettingsModel;
  public filterOption: object;
 
  public data: any;
  gridData: any;
  public pageSizes: number[] = [10, 15, 20, 50, 100, 250];

  private onDestroy$: Subject<void> = new Subject<void>();
  gridTemplateBO: GetHandbookBO = new GetHandbookBO()
  ClientTemplateBO: clientTemplate = new clientTemplate()
  employeeTemplateBO: employeeTemplate = new employeeTemplate()
  fp: functionpermission = new functionpermission()
  isSaveorUpdateBoolean:boolean=false;
  statusList: any = [];
  public TemplateList = []

  emit_boolean = false
  agencycheck: false
  allEmployeeDropDown:any=[]
  allClientDropDown:any=[]
  formatDateOptions:Object;
  logintype:string=null;
  constructor(public DataService: HandBookService, public clientservice: ClientHttpService, public global: GlobalComponent, private toast: ToastrService,private sanitizer:DomSanitizer


  ) {
    this.global.checkforlogout();
    this.data = DataService;
  }

  ngOnInit(): void {
    this.logintype = localStorage.getItem("CFSS_checkType");
    this.formatDateOptions = { type: "date", format: "MM/dd/yyyy" };

    if (
      (this.global.globalAgencyId == null ||
        this.global.globalAgencyId == undefined ||
        this.global.globalAgencyId == "" ||
        this.global.globalAgencyId == "00000000-0000-0000-0000-000000000000") && (this.global.agencyCode == 'SUPERADMIN')) {
      return;
    }
    this.getHandBookList();
   
    this.pageSettings = {
      currentPage: 1,
      totalRecordsCount: 0,
      pageCount: 10,
      pageSize: this.pageSizes[0],
      pageSizes: this.pageSizes,
    };
    this.filterOption = {
      type: "Menu",
    };
    this.getpermission();
 
  }

  getpermission() {
    if (this.global.LoginUserType.toUpperCase() != 'ONBOARD' && (this.global.globalAgencyId != null && this.global.globalAgencyId != undefined && this.global.globalAgencyId != '')) {
      let params = new URLSearchParams();
      params.append("pagecode", "HANDBOOK");
      params.append("roleId", this.global.roleId);
      params.append("agencyId", this.global.globalAgencyId)
      this.DataService.getpermission(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
        if (data != null) {
          this.fp = data;
        }
        else {
          this.fp = new functionpermission();
        }
      },
        (err: HttpErrorResponse) => {
          this.fp = new functionpermission();
        })
    }
  }
  getAllEmployeeDropDown() {

     let params=new URLSearchParams();
     params.append("agencyId",this.global.globalAgencyId);
    this.DataService.GetAllEmployeeForAgencyHandBook(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      if (data != null) {
        this.allClientDropDown = data;
        console.log("allEmployeeDropDown",this.allEmployeeDropDown);
      }
    
    },
      (err: HttpErrorResponse) => {
       
      })

  }

 

 

  /////////////////////// Edit Template ////////////////////
  edit(data) {
    document.getElementById("templateNameModal").click();
   this.documentList.filePath=data.filePath;
   this.documentList.handbookName=data.handbookName;
   this.documentList.id=data.id;
   let basevalue:any;
   if (data.fileString != null && data.fileString != undefined) {
    basevalue =  this.tobase64(this.documentList.fileString);
    console.log("basevalue edit",basevalue);
    data.fileString = basevalue.__zone_symbol__value;
  }
  }
 

  getHandBookList() {
   
    this.gridTemplateBO.agencyId = (this.global.globalAgencyId != "" && this.global.globalAgencyId != null && this.global.globalAgencyId != undefined) ? this.global.globalAgencyId : "00000000-0000-0000-0000-000000000000"
    this.DataService.executeClient(this.gridTemplateBO);
    this.data.pipe(takeUntil(this.onDestroy$)).subscribe((data) => {
      this.gridData = data.result;
    },
      (err: any) => {
        this.toast.error(err.error.Request, "error");
      });
    
  }
  ///////////////////////template type////////////////////

 

  refresh() {
    this.getHandBookList();
  }

  //........................................TAPCHANGE.......................................
  PrivatePaySelectedTab = 'Client'

 

  clearName() {
    this.ClientTemplateBO.templatename = ''
    this.employeeTemplateBO.templateName = ''
    this.ClientTemplateBO.datalist = ''
    this.employeeTemplateBO.datalist = ''
     this.selectedDocumentFileName =null;
     this.documentList = new HandbookBO();
  }

  dataChangeAgreement(temp) {
    let val = temp.action.requestType.toString();
    if (val != "filterchoicerequest") {
      if ((temp.sorted || []).length) {
        this.gridTemplateBO.orderColumn = temp.sorted[0].name;
        this.gridTemplateBO.orderType =
          temp.sorted[0].direction === "descending" ? "DESC" : "ASC";
      }
    }
    if (val == "filtering" && temp.action.action != "clearFilter") {
      this.gridTemplateBO.value = temp.action.currentFilterObject.value;
      this.gridTemplateBO.field = temp.action.currentFilterObject.field;
      this.gridTemplateBO.matchCase = temp.action.currentFilterObject.matchCase;
      this.gridTemplateBO.operator = temp.action.currentFilterObject.operator;
      if (this.gridTemplateBO.type == "number") {
        this.gridTemplateBO.value =
          temp.action.currentFilterObject.value.toString();
        this.gridTemplateBO.field = temp.action.currentFilterObject.field;
      }
    } else {
      if (val == "filtering" && temp.action.action == "clearFilter") {
        this.gridTemplateBO.field = "handbookName";
        this.gridTemplateBO.matchCase = false;
        this.gridTemplateBO.operator = "contains";
        this.gridTemplateBO.value = "";
        this.gridTemplateBO.type = "string";
      }
    }
    this.getHandBookList();
  }

  onActionAgreement(r) {
    this.gridTemplateBO.currentpageno =
      this.grid.pagerModule.pagerObj.currentPage;
    this.gridTemplateBO.pageitem = this.grid.pagerModule.pagerObj.pageSize;
    if (r.name == "actionBegin" && r.requestType == "filterbeforeopen") {
      this.gridTemplateBO.type = r.columnType;
    }
  }

  showColumns() {
    this.grid.columnChooserModule.openColumnChooser(200, 50);
  }

  showColumnsOne() {
    this.gridEmp.columnChooserModule.openColumnChooser(200, 50);
  }

  dataChangeAgreementEmp(temp) {
    let val = temp.action.requestType.toString();
    if (val != "filterchoicerequest") {
      if ((temp.sorted || []).length) {
        this.gridTemplateBO.orderColumn = temp.sorted[0].name;
        this.gridTemplateBO.orderType =
          temp.sorted[0].direction === "descending" ? "DESC" : "ASC";
      }
    }
    if (val == "filtering" && temp.action.action != "clearFilter") {
      this.gridTemplateBO.value = temp.action.currentFilterObject.value;
      this.gridTemplateBO.field = temp.action.currentFilterObject.field;
      this.gridTemplateBO.matchCase = temp.action.currentFilterObject.matchCase;
      this.gridTemplateBO.operator = temp.action.currentFilterObject.operator;
      if (this.gridTemplateBO.type == "number") {
        this.gridTemplateBO.value =
          temp.action.currentFilterObject.value.toString();
        this.gridTemplateBO.field = temp.action.currentFilterObject.field;
      }
    } else {
      if (val == "filtering" && temp.action.action == "clearFilter") {
        this.gridTemplateBO.field = "handbookName";
        this.gridTemplateBO.matchCase = false;
        this.gridTemplateBO.operator = "contains";
        this.gridTemplateBO.value = "";
        this.gridTemplateBO.type = "string";
      }
    }
    this.getHandBookList();

  }

  onActionAgreementEmp(r) {
    this.gridTemplateBO.currentpageno =
    this.gridEmp.pagerModule.pagerObj.currentPage;
    this.gridTemplateBO.pageitem = this.gridEmp.pagerModule.pagerObj.pageSize;
    if (r.name == "actionBegin" && r.requestType == "filterbeforeopen") {
      this.gridTemplateBO.type = r.columnType;
    }
  }
  documentList:HandbookBO =new HandbookBO();
  selectedDocumentFileName:any;
  onDOCFileChanged(files) {
   
    console.log("files",files);
    let val = files.item(0);
    this.documentList.fileString = files.item(0);
    this.selectedDocumentFileName = files.item(0)?.name;
    this.documentList.fileName= files.item(0)?.name;
    if(files.item(0)?.length==0){
      this.selectedDocumentFileName=''
    }
  }
  pdfsrc:any;
async  savehandbook(val) {
  this.isSaveorUpdateBoolean=true;
    console.log("val",val);
    let basevalue: any;
    if (val.fileString != null && val.fileString != undefined) {
      basevalue = await this.tobase64(this.documentList.fileString);
      console.log("basevalue",basevalue);
      val.fileString = basevalue;
    }
    this.DataService.SaveHandbook(val).pipe(takeUntil(this.onDestroy$)).subscribe(
     
      (data: any) => {
        this.isSaveorUpdateBoolean=false;
       if(data) {
        document.getElementById("templateNameModal").click();
        this.getHandBookList();
       }

      }, (err: any) => {
        this.isSaveorUpdateBoolean=false;
       console.log(err)
       this.toast.error(err.Message), 8000;

      });
  }
  
  tobase64 = value => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(value);
    reader.onload = (e: any) => resolve(e.target.result);
    reader.onerror = error => reject(error);
  });
  downloadFile(data) {
    var data1 = data.returnString;
    if (data1 != null) {
      window.open(data1);
    }
  }
  deletedId:any;
  deleteHandbook(Deletedid) {
      this.deletedId=Deletedid;
  }
  Delete() {
    let param = new URLSearchParams()
    param.append("HandBookId", this.deletedId)
    this.DataService.DeleteHandBook(param).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.toast.success("Handbook Deleted successfully!");
      document.getElementById("openHandbookdelete").click();
     this.getHandBookList();
    },
      (err: any) => {
        if (err) {
          this.toast.error(err, 'Error'), 8000;
        }
      });
  }
  getViewHandBook(HandbookId) {
    let params=new URLSearchParams();
    this.pdfsrc = null;
    params.append("HandbookId",HandbookId);
    let url;
    if(this.global.OnboardingLoginType =='onboardLogin')
      {
         url = "api/Client_Handbook/getHandbookDocBase64?";
      }
      else{

         url = "api/Handbook/getHandbookDocBase64?";
      }
   this.DataService.GetViewHandBook(params,url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
    console.log("data",data)
     if (data) {
      document.getElementById("ViewHandbook22").click();
       this.pdfsrc = this.sanitizer.bypassSecurityTrustResourceUrl('data:application/pdf;base64,' + data);
       console.log("pdfsrc",this.pdfsrc);
     }
   },
     (err: any) => {
      this.toast.error(err, "Error");
     })
  }
}
